<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Roles y permisos</h4>
        </div>
        <div class="card-body">
            <div class="row">
              <!-- <div v-if="group_id == ''" class="card-body">
                  <img class="no_data_center"  v-bind:src="no_data_image" alt="">
              </div> -->
              <div class="col-sm-12">
                  <fg-input name="rol">
                    <el-select @change="resetModule()" class="select-warning"
                                size="large"
                                placeholder="Seleccione un Rol"
                                v-model="group_id">
                        <el-option v-for="option in groups_array"
                                class="select-warning"
                                :value="option.id"
                                :label="option.name"
                                :key="option.id">
                        </el-option>
                    </el-select>
                  </fg-input>
              </div>
              <div v-if="group_id != ''" class="col-sm-12">
                  <fg-input name="module">
                    <el-select @change="resetPermissions()" class="select-warning"
                                size="large"
                                placeholder="Seleccione un módulo"
                                v-model="module_id">
                        <el-option v-for="option in modules_array"
                                class="select-warning"
                                :value="option.id"
                                :label="option.name"
                                :key="option.id">
                        </el-option>
                    </el-select>
                  </fg-input>
              </div>
            </div>
        </div>
      </div>  <!-- end card -->
      <!--Loading state-->
      <loading :active.sync="this.$apollo.queries.modules.loading"
      :can-cancel="false" 
      :is-full-page="fullPage">
      </loading>
      <!--./Loading state-->
      <!--Sending state-->
      <loading :active.sync="isSending"
      :can-cancel="false" 
      :is-full-page="fullPage">
      </loading>
      <!--./Sending state-->
      <div v-if="module_id != ''" class="card">
        <div class="card-header">
          <h4 class="card-title">Seleccione los permisos</h4>
        </div>
        <div class="card-body">
            <fieldset>
                <div class="form-group">
                    <div v-for="permission in permissions_array_computed" :key="permission.id" class="col-sm-12">
                      <p-checkbox :inline="true" v-model="permission.check">{{permission.name}}</p-checkbox>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="card-footer">
            <div class="text-right">
                <p-button @click="sendForm()" type="success">Aceptar</p-button>
                <p-button @click="cancelForm()" type="default" class="pull-left">Cancelar</p-button>
            </div>
        </div>
      </div>
    </div> <!-- end col-md-12 -->
  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { Card } from 'src/components/UIComponents'
  import { Input, Select, Option, Checkbox} from 'element-ui'
  import gql from 'graphql-tag'
  import { modules } from 'src/api/graphql/queries/group/AllModules';
  import { groups } from 'src/api/graphql/queries/group/AllGroups';
  import { permissions } from 'src/api/graphql/queries/group/AllPermissions';
  import { SET_GROUP_PERMISSIONS } from 'src/api/graphql/mutations/group/SetGroupPermissions';
  import { orderBy , sortBy , find } from 'lodash';
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Checkbox)
  export default {
    /***
    * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
    *
    **/
    apollo:{
        groups: {
                query: groups,
                // Disable the query
                skip() {
                  return this.skipGroupQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.groups.edges.length == 0)
                    {
                        this.groups_array = [];
                    }
                    else
                    {
                        this.setGroups(data.groups);
                        this.skipGroupQuery = true;
                        // this.$apollo.queries.groups.skip = true;
                    }
                    
                },
                // Si encontró algún error.
                error(error) {
                    
                },
            },
        modules: {
                query: modules,
                // Disable the query
                skip() {
                  return this.skipModulesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.modules.edges.length == 0)
                    {
                        this.modules_array = [];
                    }
                    else
                    {
                        this.setModules(data.modules);
                        this.skipModulesQuery = true;
                        // this.$apollo.queries.groups.skip = true;
                    }
                    
                },
                // Si encontró algún error.
                error(error) {
                    
                },
        },
        // permissions: {
        //         query: permissions,
        //         skip: false,
        //         fetchPolicy: 'network-only',
        //         // Si tenemos un resultado, pero no encontró el slug.
        //         result({ data, loading, networkStatus }) {
                    
        //             if(data.permissions.edges.length == 0)
        //             {
        //                 this.permissions_array = [];
        //             }
        //             else
        //             {
        //                 this.setPermissions(data.permissions);
        //                 this.$apollo.queries.permissions.skip = true;
        //             }
                    
        //         },
        //         // Si encontró algún error.
        //         error(error) {
                    
        //         },
        //     },
    },
    components: {
      Card,
      Select,
      Checkbox,
      Option,
      Loading
    },
    data() {
      return {
        skipGroupQuery: false,//bandera para saltar la query de groups
        skipModulesQuery: false,//bandera para saltar la query de groups
        no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/permissions.png',
        modules_array: [],//arreglo de módulos del sistema
        groups_array: [],//arreglo de grupos del sistema
        permissions_array: [],//arreglo de permisos del sistema
        permissions_group_array: [],//arreglo de permisos asignados a un grupo en la mutación
        group_id:'',//id del grupo a enviar en la mutación
        module_id:'',//id del módulo a enviar en la mutación
        isSending: false,//bandera para mostrar el loading en caso de envío de datos
        fullPage: false,//bandera para mostrar el loading en pantalla completa en caso de envio de datos
      }
    },
    watch: {
      
    },
    computed: {
      permissions_array_computed: {
        get: function () {
                    var vm = this;
                    var final_permissions = [];
                    final_permissions = this.permissions_array.filter((tableRow) => tableRow.moduleId === vm.module_id)
                    return final_permissions;
                },
        
      }
    },
    methods: {

      /***
       * Función que resetea el módulo
       */
      resetModule(){
        this.module_id = '';
      },
      /***
       * Función que resetea los permisos y asigna y visualiza los del grupo seleccionado
       */
      resetPermissions(){
        var vm = this;
        vm.isSending = true;
        vm.permissions_group_array = [];
        vm.permissions_array.forEach(function(element){
          element.check = false;
        });
        let findGroup = this.groups_array.find((tableRow) => tableRow.id === vm.group_id)
        vm.permissions_array.forEach(function(element){
          for(var i=0;i<findGroup.permissions.edges.length;i++)
          {
            if(findGroup.permissions.edges[i].node.id == element.id)
            {
              element.check = true;
            }
          }
        });
        vm.isSending = false;
      },
      /***
       * Función para cancelar la edición de roles y permisos
       */
      cancelForm(){
        var vm = this;
        vm.group_id = '';
        vm.module_id = '';
        vm.permissions_group_array = [];
      },
      /***
       * Función para setear en la tabla los datos que llegan desde los módulos
       */
      setModules(modules){
          var vm = this;
          vm.modules_array = [];
          for(let i=0;i<modules.edges.length;i++)
          {
              vm.pushModulesData(modules.edges[i].node);
          }
          vm.orderModulesData();
      },
      /***
       * Función para setear en la tabla los datos que llegan desde los grupos
       */
      setGroups(groups){
          var vm = this;
          vm.groups_array = [];
          for(let i=0;i<groups.edges.length;i++)
          {
              vm.pushGroupsData(groups.edges[i].node);
          }
          vm.orderGroupsData();
      },
      /***
       * Función para setear en la tabla los datos que llegan desde los permisos
       */
      setPermissions(permissions){
          var vm = this;
          for(let i=0;i<permissions.edges.length;i++)
          {
              vm.pushPermissionsData(permissions.edges[i].node);
          }
          vm.orderPermissionsData();
      },
      /***
      * Función para agregar un objeto al arreglo de datos de módulos
      */
      pushModulesData(node){
          var vm = this;
          vm.modules_array.push({
              id: node.id,
              appLabel: node.appLabel,
              name: node.name
          });
          for(let i=0;i<node.permissionSet.edges.length;i++)
          {
              vm.pushPermissionsData(node.permissionSet.edges[i].node,node.id);
          }
          vm.orderPermissionsData();
          vm.orderModulesData();
      },
      /***
      * Función para agregar un objeto al arreglo de datos de grupos
      */
      pushGroupsData(node){
          var vm = this;
          vm.groups_array.push({
              id: node.id,
              name: node.name,
              permissions: node.permissions
          });
      },
      /***
      * Función para agregar un objeto al arreglo de datos de permisos
      */
      pushPermissionsData(node,moduleId){
          var vm = this;
          var check = false;
          vm.permissions_array.push({
              moduleId: moduleId,
              id: node.id,
              name: node.name,
              check: check
          });
      },
      /***
      * Función para ordenar el arreglo de datos de modulos
      */
      orderModulesData(){
          var vm = this;
          const myOrderedArray = _.sortBy(vm.modules_array, o => o.name);
          vm.modules_array = myOrderedArray;
      },
      /***
      * Función para ordenar el arreglo de datos de regionales
      */
      orderGroupsData(){
          var vm = this;
          const myOrderedArray = _.sortBy(vm.groups_array, o => o.name);
          vm.groups_array = myOrderedArray;
      },
      /***
      * Función para ordenar el arreglo de datos de permisos
      */
      orderPermissionsData(){
          var vm = this;
          const myOrderedArray = _.sortBy(vm.permissions_array, o => o.name);
          vm.permissions_array = myOrderedArray;
      },
      /*** 
      * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
      */
      onSuccess(message){
          swal({
              title: `¡Correcto!`,
              text: message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
          });
      },
      /*** 
      * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
      */
      onError(message){
          swal({
              title: `¡Alerta!`,
              text: message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger btn-fill',
              type: 'error'
          });
      },
      /***
      * Función para decodificar el ID en base 64
      */
      idDecode(id){
          let id_decoded = atob(id);
          return id_decoded.split(":")[1];
      },
      /***
      * Función para volver a cargar el grupo
      */
      refetchGroup(){
          this.$apollo.queries.groups.skip = false;
          this.$apollo.queries.groups.refetch();
          
      },
      /*** 
      * Función que envía al servidor la mutación de roles y permisos
      */
      sendForm(){
        var vm = this;
        if(vm.group_id != '')
        {
          vm.permissions_group_array = [];
          vm.permissions_array.forEach(function(element){
            if(element.check)
            {
              vm.permissions_group_array.push(
                vm.idDecode(element.id)
              )
            }
          });
          if(vm.permissions_group_array.length > 0)
          {
            vm.isSending = true;
            // Iniciamos el envío de la mutación
            this.$apollo.mutate({
                mutation: SET_GROUP_PERMISSIONS,
                variables : {
                  input:{
                    group : vm.idDecode(vm.group_id),
                    permissions: vm.permissions_group_array
                  }
                }
            }).then((data) => {
                vm.isSending = false;
                vm.onSuccess("Permisos modificados correctamente");
                vm.cancelForm();
                vm.refetchGroup();               
            }).catch((error) => {
                vm.isSending = false;
                vm.onError('Ha ocurrido un error, inténtalo de nuevo');
            });
          }
          else
          {
            vm.onError("No se puede establecer un rol sin permisos")
          }
        }
        else
        {
          vm.onError("No hay un rol seleccionado")
        }
      }
    }
  }
</script>
<style lang="scss">
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
</style>
